// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3zWUX","title":"Images90_title__1LALG","images":"Images90_images__L9zEl"};